import React from 'react';
import { Formik } from "formik";
import * as Yup from "yup";
import Cookies from "js-cookie";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import api from "../../api/index";

const NewGameSchema = Yup.object().shape({
  gameCode: Yup.number()
    .min(0)
    .max(9999)
    .required('Required'),
});

function OpenDashboardForm()
{
  const { t } = useTranslation();
  const navigate = useNavigate();

  let handleSubmit = (values, { setSubmitting }) => {
    api.getGameByCode(values.gameCode).then((response) => {
        if (response.status === 200) {
            const data = response.data;
            Cookies.set("game_id", data.secret);
            Cookies.set("game_code", data.game_code);
            setSubmitting(false);
            navigate(`/app/digiboard/onboard/${data.secret}${window.location.search}`);
        }
    });
  };

  return(
    <Formik
      initialValues={{ gameCode: '' }}
      validationSchema={NewGameSchema}
      onSubmit={handleSubmit}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      })=> (
        <form onSubmit={handleSubmit}>
          <label>{ t("digiboard.open.text") }</label>
          <div className="input-wrapper">
            <input
                type="text"
                name="gameCode"
                value={values.gameCode}
                onBlur={handleBlur}
                onChange={handleChange}
            />
          </div>
           <p className="validation">
              {errors.gameCode && touched.gameCode && errors.gameCode}
          </p>
          <button type="submit" disabled={isSubmitting}>
          { t("digiboard.open.button_text") }
          </button>
        </form>
      )}
    </Formik>
  );
}

export default OpenDashboardForm;